// ----------------------------- static data
// (generate using list-files.php tool)
// ----------------------------- static data
// (generate using list-files.php tool)
import AssetManager from "lib/src/AssetManager";
import Utils from "lib/src/utils";
import MouseEvent = createjs.MouseEvent;
import * as $ from "jquery";

let DATA = {
    arabella: {
        stamps: ["01_Arabella_Jumping.png", "02_Arabella_Umbrella.png", "03_Arabella_on_Balloon.png", "04_King_dad_Calender.png", "05_mamaarabella.png", "06_Ling_02.png", "07_Ling_Present.png", "08_Mimoen_01.png", "09_sophie.png", "11_Arabella_on_Elephant.png", "12_Dog_Pencil_Art.png", "13_Stuffed_Elephant_05.png", "14_Arabella_Arms_Crossed.png", "15_Animal_Cat.png", "16_Dier_dood.png", "17_StuffedElephant02.png", "18_Stuffed_Elephant_01.png", "19_Elephant_in_Bag.png", "20_Icon_Heart_Box.png", "21_Taart2.png"],
    },
    chloe: {
        stamps: [ "01_CL_04.png", "02_CH_PRI_03.png", "03_TARA_01.png", "04_TARA_PRI_02.png", "05_JET_03.png", "06_JET_PRI_02.png", "07_LC_04.png", "08_LC_05.png", "09_PROP_VET_11-2.png", "10_PROP_VET_11-3.png", "11_PROP_VET_11-1.png", "12_PROP_VET_12.png", "13_PROP_08.png", "13_PROP_VET_08.png", "14_prop_16.png", "15_CC_V_Balloon.png", "16_CC_V_Helicopter.png", "17_CC_V_Sleigh.png", "18_CC_V_TrainEngine.png", "19_CP637-001-PLANE-3.png", "20_PROP_PRI_02.png", "21_PROP_VET_01.png", "22_CC_V_BoulderCar.png", "23_PROP_01.png", "24_prop_19.png", "25_PROP_05.png", "26_PROP_BAL_04.png", "28_PROP_BAK_06.png", "29_PROP_09.png", "30_ICON_10_A.png", "31_ICON_10_B.png" ],
    },
};

// -----------------------------

let STAMP_MARGIN = 20;
let character = Utils.getParameterByName("character") || "chloe";
let bgImg = Utils.getParameterByName("bg") || "CL012-001.jpg";
let data = DATA[character];

export default class Stamping {

    private FPS = 60;

    private _canvas;
    private _stage;
    private _bitmap;
    private _stampContainer;
    private _stamps;
    private _stampsBg;
    private _activeStamp;
    private _drawingContainer;
    private _stampWidth;
    private _btnDelete;

    public start(canvas) {
        // resize canvas to fullscreen
        canvas.width = $("html").width();
        canvas.height = $("html").height();

        let img = new Image();
        img.onload = () => {
            this.init(canvas, img);
        };
        img.src = AssetManager.getForChar("bg/" + bgImg);
    }

    private init(canvas, img) {
        this._canvas = canvas;
        this._stage = new createjs.Stage(this._canvas);
        if (createjs.Touch.isSupported()) {
            createjs.Touch.enable(this._stage, true);
        }

        let stageW = this._canvas.width;
        let stageH = this._canvas.height;

        this._bitmap = new createjs.Bitmap(img);
        // resize (fit): make sure bg image fits the entire screen
        let scale = Math.max(stageW / img.width, stageH / img.height);
        this._bitmap.scaleX = scale;
        this._bitmap.scaleY = scale;
        // center
        this._bitmap.x = (stageW / 2) - (img.width * this._bitmap.scaleX) / 2;
        this._bitmap.y = (stageH / 2) - (img.height * this._bitmap.scaleY) / 2;

        this._bitmap.on("click", (evt) => {
            this.clickHandler(evt);
        });
        this._stage.addChild(this._bitmap);

        this._drawingContainer = new createjs.Container();
        this._stage.addChild(this._drawingContainer);

        this._stampWidth = this._canvas.width / 10;

        // preload images
        let manifest = [];
        manifest.push({src: AssetManager.getShared("close-icon.png"), id: "close-icon"});
        manifest.push({src: AssetManager.getShared("trash-icon.png"), id: "delete-icon"});
        for (let i = 0; i < data.stamps.length; i++) {
            manifest.push({src: AssetManager.getForChar("stamps/" + data.stamps[i]), id: "stamp" + i});
        }
        // false: otherwise android won't load (tested on 6.0.1)
        let preload = new createjs.LoadQueue(false);
        preload.on("complete", (evt) => {
            this.addStamps(evt);
        });
        preload.loadManifest(manifest, true);

        // ticker
        createjs.Ticker.timingMode = createjs.Ticker.RAF_SYNCHED;
        createjs.Ticker.framerate = this.FPS;
        createjs.Ticker.addEventListener("tick", () => {
            this._stage.update();
        });
    }

    private addStamps(event) {

        let q = event.target;

        // Add delete button
        this._btnDelete = new createjs.Bitmap(q.getResult("delete-icon"));
        let bounds = this._btnDelete.getBounds();
        this._btnDelete.visible = false;
        this._btnDelete.x = 10 + (bounds.width / 2);
        this._btnDelete.y = this._canvas.height - (bounds.height / 2);
        this._btnDelete.regX = bounds.width / 2;
        this._btnDelete.regY = bounds.height / 2;
        this._stage.addChild(this._btnDelete);

        this._stampContainer = new createjs.Container();
        this._stampContainer.width = this._stampWidth;
        this._stampContainer.x = this._canvas.width - this._stampWidth;

        let stampsIds = [];
        for (let i = 0; i < data.stamps.length; i++) {
            stampsIds.push("stamp" + i);
        }

        this._stampsBg = new createjs.Shape();
        this._stampContainer.addChild(this._stampsBg);
        this._stampContainer.isScrolling = false;

        let y = 0;
        this._stamps = [];
        $(stampsIds).each((i, id) => {
            let img = q.getResult(id);
            let stamp = new createjs.Bitmap(img);
            let scale = Math.min(1, this._stampWidth / img.width);
            stamp.scaleX = scale;
            stamp.scaleY = scale;
            // if there is horizontal space left, center the stamp
            stamp.x = (this._stampWidth - (img.width * scale)) / 2;
            stamp.y = y;
            y += img.height * stamp.scaleY;
            // some space between stamps
            y += STAMP_MARGIN;

            // make entire stamp rect clickable (especially handy for phones)
            let hit = new createjs.Shape();
            hit.graphics.beginFill("#000").rect(0, 0, img.width, img.height);
            stamp.hitArea = hit;

            this._stampContainer.addChild(stamp);

            this._stamps.push(stamp);

            stamp.on("click", (e) => {
                console.log("click stamp");

                // was a scroll, not a click
                if (this._stampContainer.isScrolling) {
                    return;
                }
                this._activeStamp = stamp;
                this.drawStampBg();

                this._stage.update();

                return true;
            });
        });

        let containerHeight = y;
        this._stampContainer.height = containerHeight;
        this._stage.addChild(this._stampContainer);

        // fill background
        this._activeStamp = this._stamps[0];
        this._stampsBg.width = this._stampWidth;
        this._stampsBg.height = containerHeight;
        this.drawStampBg();

        // make container draggable
        this._stampContainer.on("mousedown", (e) => {
            console.log("mousedown bg");
            this._stampContainer.mouseStart = new createjs.Point(e.stageX, e.stageY);
            this._stampContainer.scrollStart = this._stampContainer.y;
        });
        this._stampContainer.on("pressmove", (e) => {

            let mousePos = new createjs.Point(e.stageX, e.stageY);

            if (Math.abs(mousePos.x - this._stampContainer.mouseStart.x) < 3 &&
                Math.abs(mousePos.y - this._stampContainer.mouseStart.y) < 3) {
                // very small scroll, treat as a normal click
                // (finger accidentally moved while clicking)
                return;
            }

            // scroll of more then 3 pixels, start scrolling
            this._stampContainer.isScrolling = true;

            let minOffset = -containerHeight + this._canvas.height;
            let maxOffset = 0;

            let offset = this._stampContainer.scrollStart + (mousePos.y - this._stampContainer.mouseStart.y);
            if (offset < minOffset || offset > maxOffset)  {
                // no more area left to scroll
                return;
            }
            this._stampContainer.y = offset;
            this._stage.update();
        });
        this._stampContainer.on("pressup", (e) => {
            console.log("pressup");
            this._stampContainer.isScrolling = false;
        });

        this._stage.update();
    }

    private drawStampBg() {

        let bounds = this._activeStamp.getTransformedBounds();
        let nonselectedColor = "rgba(0,0,0,0.5)";
        let selectedColor = "rgba(255,255,255,0.5)";
        let idx = this._stamps.indexOf(this._activeStamp);

        let y
        let height;
        let isLast = idx === this._activeStamp.length - 1;
        
        this._stampsBg.graphics.clear();

        // fill area above selected stamp
        let isFirst = idx === 0;
        if (!isFirst) {
            y = 0;
            height = bounds.y - (STAMP_MARGIN / 2);
            this._stampsBg.graphics.beginFill(nonselectedColor).rect(0, y, this._stampWidth, height);
        }

        // active stamp
        y = Math.max(0, bounds.y - (STAMP_MARGIN / 2));
        // for first/last, we only have one margin to fill
        height = bounds.height + (isFirst || isLast ? STAMP_MARGIN / 2 : STAMP_MARGIN);

        console.log("fill " + bounds.y + " to " + bounds.height);
        this._stampsBg.graphics.beginFill(selectedColor).rect(0, y, this._stampWidth, height);

        // fill area under stamp

        if (!isLast) {
            y = bounds.y + bounds.height + STAMP_MARGIN / 2;
            height = this._stampsBg.height - y;
            this._stampsBg.graphics.beginFill(nonselectedColor).rect(0, y, this._stampWidth, height);
        }
    }

    private clickHandler(evt) {
        if (this._activeStamp === undefined) {
            return;
        }

        let bitmap = new createjs.Bitmap(this._activeStamp.image);
        bitmap.x = evt.stageX;
        bitmap.y = evt.stageY;
        bitmap.regX = bitmap.image.width / 2;
        bitmap.regY = bitmap.image.height / 2;
        let scale = this._stampWidth / bitmap.image.width;
        bitmap.scaleX = scale;
        bitmap.scaleY = scale;

        bitmap.on("pressmove", (e: MouseEvent) => {
            let mousePos = new createjs.Point(e.stageX, e.stageY);

            // move item
            bitmap.x = e.stageX;
            bitmap.y = e.stageY;

            // show garbage icon (with animation)
            if (!this._btnDelete.visible) {
                this._btnDelete.scaleX = 0;
                this._btnDelete.scaleY = 0;
                let tween = createjs.Tween.get(this._btnDelete)
                    .to({scaleX: 1.5, scaleY: 1.5}, 300)
                    .to({scaleX: 1, scaleY: 1}, 200);
                this._btnDelete.visible = true;
            }

            // mouse on the garbage icon?
            let bounds = this._btnDelete.getTransformedBounds();
            // var pt = this._btnDelete.globalToLocal(e.stageX, e.stageY);
            // if (this._btnDelete.hitTest(pt.x, pt.y)) {
            // Use square hit area, not pixel-based
            if (e.stageX >= bounds.x && e.stageY >= bounds.y &&
                    e.stageX <= (bounds.x + bounds.width) &&
                    e.stageY <= (bounds.y + bounds.height)) {
                this._btnDelete.scaleX = 1.2;
                this._btnDelete.scaleY = 1.2;
                this._btnDelete.isMouseOver = true;
            } else {
                if (this._btnDelete.isMouseOver) {
                    this._btnDelete.isMouseOver = false;
                    this._btnDelete.scaleX = 1;
                    this._btnDelete.scaleY = 1;
                }
            }

            this._stage.update();
        });
        bitmap.on("pressup", (e) => {

            if (this._btnDelete.isMouseOver) {
               // actual delete
                this._drawingContainer.removeChild(bitmap);
                this._btnDelete.isMouseOver = false;
           }

            // remove button
            let tween = createjs.Tween.get(this._btnDelete)
                .to({scaleX: 0, scaleY: 0}, 300)
                .call(() => {
                    this._btnDelete.visible = false;
                });

            this._stage.update();
        });
        this._drawingContainer.addChild(bitmap);

        this._stage.update();
    }

}



// WEBPACK FOOTER //
// ./src/Stamping.ts